// hooks/useBranding.ts
import { useEffect, useCallback } from "react";
import { manifestForPlugIn } from "../../manifest.ts";
import {ManifestOptions} from "vite-plugin-pwa"; // adjust path


interface BrandingOptions {
    title?: string;
    favicon?: string; // custom favicon path
    prefix?: string;
    suffix?: string;
}

export const useBranding = (options: BrandingOptions = {}) => {
    const manifest = manifestForPlugIn.manifest as Partial<ManifestOptions>;

    const {
        title = manifest?.short_name || manifest?.name || "App",
        favicon =
            manifest?.icons?.find((icon) =>
                icon.purpose?.includes(
                    "any"
                )
            )?.src || manifest?.icons?.[0]?.src,
        prefix = "",
        suffix = "",
    } = options;

    const updateTitle = useCallback(() => {
        if (typeof document === "undefined" || !title) return;
        document.title = `${prefix}${title}${suffix}`.trim();
    }, [title, prefix, suffix]);

    const updateFavicon = useCallback(() => {
        if (typeof document === "undefined" || !favicon) return;

        const link =
            document.querySelector<HTMLLinkElement>("link[rel*='icon']") ||
            document.createElement("link");

        link.type = "image/png";
        link.rel = "icon";
        link.href = favicon;

        document.head.appendChild(link);
    }, [favicon]);

    useEffect(() => {
        updateTitle();
        updateFavicon();
    }, [updateTitle, updateFavicon]);
};
